import { capitalize } from 'lodash'
import { DISCOUNT_TYPES } from './show/types'

export const optionsDiscountType = Object.keys(DISCOUNT_TYPES).map((key) => ({
  value: key,
  label: capitalize(DISCOUNT_TYPES[key as keyof typeof DISCOUNT_TYPES]),
}))
